import './style.scss';
import SalesChannelPriceModel from '../../models/sales-channel-price';
import { Channel } from '../../../../../models/channel.enum';
import { ConfigurationService } from '../../../../../services/configuration.service';
import { TranslationService } from '../../../../../services/translation.service';
import { CurrencyHelper } from '../../../../../helpers/currency.helper';
import { useTexts } from '../../../../../hooks/texts.hook';

function SalesChannelPrice({
  salesChannelPrice,
  hideBackgroundImage = false,
  onClick,
}: {
  salesChannelPrice: SalesChannelPriceModel;
  hideBackgroundImage?: boolean;
  onClick?: (salesChannel: Channel) => void;
}) {
  // === HOOKS ===
  const { t } = useTexts();

  // === EVENT HANDLERS ===
  function handleSalesChannelClicked(salesChannel: Channel) {
    onClick?.(salesChannel);
  }

  return (
    <tr>
      {salesChannelPrice.salesChannel === Channel.toGo && (
        <td className={`py-2 d-block ${!hideBackgroundImage ? 'sales-channel-price sales-channel-price--togo' : ''}`}>
          <a href={ConfigurationService.get('ticketsuggestions.linkToToGoInformationPage')} target="_blank" onClick={() => handleSalesChannelClicked(Channel.toGo)} rel="noreferrer">
            {TranslationService.get('common.togo')}
          </a>
        </td>
      )}
      {salesChannelPrice.salesChannel === Channel.ombud && (
        <td className={`py-2 d-block ${!hideBackgroundImage ? 'sales-channel-price sales-channel-price--ombud' : ''}`}>
          <a href={ConfigurationService.get('ticketsuggestions.linkToTicketOfficeInformationPage')} target="_blank" onClick={() => handleSalesChannelClicked(Channel.ombud)} rel="noreferrer">
            {TranslationService.get('common.ticketoffice')}
          </a>
        </td>
      )}
      {salesChannelPrice.salesChannel === Channel.ombord && (
        <td className={`py-2 d-block ${!hideBackgroundImage ? 'sales-channel-price sales-channel-price--ombord' : ''}`}>
          <a href={ConfigurationService.get('ticketsuggestions.linkToOnboardInformationPage')} target="_blank" onClick={() => handleSalesChannelClicked(Channel.ombord)} rel="noreferrer">
            {t('Ombord', 'On board')}
          </a>
          <small className="d-block">{TranslationService.get('common.limitedsales')}</small>
        </td>
      )}
      {salesChannelPrice.salesChannel === Channel.tapAndGo && (
        <td className={`py-2 d-block ${!hideBackgroundImage ? 'sales-channel-price sales-channel-price--tapAndGo' : ''}`}>
          <a href={ConfigurationService.get('ticketsuggestions.linkToTapAndGoInformationPage')} target="_blank" onClick={() => handleSalesChannelClicked(Channel.tapAndGo)} rel="noreferrer">
            {TranslationService.get('common.tapandgo')}
          </a>
          <small className="d-block">{TranslationService.get('common.limitedsales')}</small>
        </td>
      )}
      <td className="text-end text-nowrap">{CurrencyHelper.toLocaleStringWithZeroOrTwoDigits(salesChannelPrice.priceInSek)}</td>
    </tr>
  );
}

export default SalesChannelPrice;
